import React, { Component } from 'react'

export class empty extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}

export default empty
